module.exports = __webpack_public_path__ + "media/sebelas.c4dc1c28.mp3";